import {Component, computed, effect, inject, input, model, OnDestroy, OnInit, untracked} from '@angular/core';
import {ChevronDownIcon, ChevronUpIcon, LucideAngularModule, LucideIconData} from 'lucide-angular';
import {AccordionService} from '@shared/container/accordion/accordion.service';

@Component({
  selector: 'app-accordion-item',
  imports: [
    LucideAngularModule
  ],
  templateUrl: './accordion-item.component.html',
  styleUrl: './accordion-item.component.scss'
})
export class AccordionItemComponent implements OnInit, OnDestroy {
  // public readonly open = model<boolean>(false);
  public readonly icon = input<LucideIconData | null>(null);
  public readonly title = input<string>('');
  public readonly expanded = model<boolean>(false);
  public readonly isOpen = computed(() => this.accordionService.openItems().has(this));
  public readonly isClosed = computed(() => !this.isOpen());
  public readonly chevron = computed(() => this.isOpen() ? ChevronUpIcon : ChevronDownIcon);

  private readonly accordionService = inject(AccordionService);

  constructor() {
    // 1. Sync: Parent (model) -> Service
    effect(() => {
      const shouldBeOpen = this.expanded();

      // 'untracked' prevents the effect from re-running if
      // the service state changes later.
      untracked(() => {
        if (shouldBeOpen !== this.isOpen()) {
          this.accordionService.setState(this, shouldBeOpen);
        }
      });
    });

    // 2. Sync: Service -> Parent (model)
    effect(() => {
      const internalState = this.isOpen();
      untracked(() => {
        if (internalState !== this.expanded()) {
          this.expanded.set(internalState);
        }
      });
    });
  }

  public ngOnInit() {
    this.accordionService.registerItem(this);
  }

  public ngOnDestroy() {
    this.accordionService.unregisterItem(this);
  }

  public toggleOpen(): void {
    if (this.accordionService.allowUserInteraction()) {
      this.accordionService.toggle(this);
    }
  }
}
